// What a sign-out hands to the next sign-in: where the person was headed, and
// whether they were pushed out rather than leaving on purpose.
//
// sessionStorage, not local: both facts belong to ONE tab's interrupted journey.
// In localStorage a second tab would inherit the first tab's destination and a
// stale "your session ended" banner long after it was true.
//
// Every read is one-shot (`take*`) — a banner that survives its own login, or a
// return-to that fires on the NEXT sign-in too, is worse than not having one.

import { safe } from "./storage";

const RETURN_TO_KEY = "authReturnTo";
const EXPIRED_KEY = "authSessionExpired";

// Only in-app paths: an absolute URL here would make the login page an open
// redirect, handing an attacker a link that authenticates and then lands the
// person on their site. "//evil.com" is protocol-relative, hence the second check.
const isInternalPath = (path) =>
  typeof path === "string" && path.startsWith("/") && !path.startsWith("//");

export const rememberReturnTo = (path) => {
  if (!isInternalPath(path) || path.startsWith("/login")) return;
  safe(() => sessionStorage.setItem(RETURN_TO_KEY, path));
};

export const takeReturnTo = () => {
  const path = safe(() => sessionStorage.getItem(RETURN_TO_KEY));
  safe(() => sessionStorage.removeItem(RETURN_TO_KEY));
  return isInternalPath(path) ? path : null;
};

export const markSessionExpired = () => {
  safe(() => sessionStorage.setItem(EXPIRED_KEY, "1"));
};

export const takeSessionExpired = () => {
  const flag = safe(() => sessionStorage.getItem(EXPIRED_KEY));
  safe(() => sessionStorage.removeItem(EXPIRED_KEY));
  return flag === "1";
};
